import { TNoticeFormData } from 'src/@types';
import { IPrSFilter } from 'src/@types/SearchFilterTypes';
import { INotice } from 'src/models';
import { TApiResponseData } from 'src/service/apiTypes';
import instance from 'src/service/axios';
import { HEADERS_MULTIPART } from 'src/static/constants';
import objectToQueryString from 'src/utils/objectToQueryString';

const SUB_URL = '/v1/notice';

const convertDataInfoToFormData = (data: TNoticeFormData) => {
  const formData = new FormData();
  // 수정일 경우 noticeSid 추가
  if (data.noticeSid) {
    formData.append('noticeSid', data.noticeSid.toString());
  }

  // 이미 등록되어있는 이미지
  if (data.filePath && data.filePath.length > 0) {
    data.filePath.forEach((file) => {
      formData.append(`filePath`, file);
    });
  }
  // 삭제할 파일
  if (data.deleteFilesPath && data.deleteFilesPath.length > 0) {
    data.deleteFilesPath.forEach((file) => {
      formData.append(`deleteFilesPath`, file);
    });
  }
  // 새로 업로드된 파일 추가
  if (data.files && data.files.length > 0) {
    data.files.forEach((file) => {
      formData.append(`files`, file);
    });
  }

  // 나머지 텍스트 데이터 추가
  formData.append('title', data.title);
  formData.append('descript', data.descript);
  formData.append('prNotiCtgyCd', data.prNotiCtgyCd?.toString() || '');
  return formData;
};

/**
 * 목록 조회
 */
export const getNotices = async (formData: IPrSFilter) => {
  try {
    const url = SUB_URL + objectToQueryString(formData);
    const response = await instance.get<TApiResponseData<INotice[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 상세 조회
 */
export const getDetail = async (noticeSid: number) => {
  try {
    const url = `${SUB_URL}/${noticeSid}`;
    const response = await instance.get<TApiResponseData<INotice>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 등록
 */
export const post = async (data: TNoticeFormData) => {
  try {
    const formData = convertDataInfoToFormData(data);
    const url = `${SUB_URL}`;

    const response = await instance.post<TApiResponseData<INotice>>(
      url,
      formData,
      HEADERS_MULTIPART,
    );

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 수정
 */
export const put = async (noticeSid: number, data: TNoticeFormData) => {
  try {
    const formData = convertDataInfoToFormData(data);
    const url = `${SUB_URL}/${noticeSid}`;

    const response = await instance.put<TApiResponseData<INotice>>(
      url,
      formData,
      HEADERS_MULTIPART,
    );

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 삭제
 */
export const remove = async (noticeSid: number) => {
  try {
    const url = `${SUB_URL}/${noticeSid}`;
    const response = await instance.delete<TApiResponseData<INotice>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
